'use client';
import { BASE_URL } from '@/common/constants';
import { getWebsiteCodeHeader } from '@/common/pageConfig';
import { useRecaptcha } from '@/common/useRecaptcha';
import Toast from '@/common/Toast';
import { useTranslations } from 'next-intl';

import { useEffect, useState } from 'react';
const phoneRegex = /^[0-9]{9,11}$/; // Ví dụ: 10–11 chữ số
const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
export default function FeebackPage({ id, locale, websiteCode }) {
  const [message, setMessage] = useState('');
  const [showPopup, setShowPopup] = useState(false);
  const [page, setPage] = useState(1);
  const t = useTranslations('');
  const [totalPages, setTotalPages] = useState(1);
  const [toastMessage, setToastMessage] = useState('');
  const [showToast, setShowToast] = useState(false);
  const { execute } = useRecaptcha();

  const [formData, setFormData] = useState({
    fullName: '',
    phoneNumber: '',
    email: '',
  });

  const handleSave = () => {
    if (!message.trim()) {
      setFormErrors((prev) => ({ ...prev, message: 'Vui lòng nhập nội dung phản hồi' }));
      return;
    }

    setFormErrors((prev) => ({ ...prev, message: '' })); // ✅ xóa lỗi nếu hợp lệ
    setShowPopup(true);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const [feedbacks, setFeedbacks] = useState([]);
  const [formErrors, setFormErrors] = useState({
    fullName: '',
    phoneNumber: '',
    message: '', // ✅ thêm dòng này
    email: '',
  });
  const fetchFeedbacks = async (pageNumber) => {
    const res = await fetch(`${BASE_URL}/feedbacks?page=${pageNumber}&limit=5&letterId=${id}&status=approved`, {
      headers: {
        websiteCode: getWebsiteCodeHeader(websiteCode),
        'Content-Type': 'application/json',
      },
    });
    const result = await res.json();
    setFeedbacks(result);
    setTotalPages(result.totalPages);
  };

  const handleSubmit = async () => {
    const errors = {
      fullName: !formData.fullName ? 'Vui lòng nhập họ và tên' : '',
      phoneNumber: !formData.phoneNumber ? 'Vui lòng nhập số điện thoại' : !phoneRegex.test(formData.phoneNumber) ? 'Số điện thoại không hợp lệ' : '',
      email: !formData.email ? 'Vui lòng nhập email' : !emailRegex.test(formData.email) ? 'Email không hợp lệ' : '',
    };

    setFormErrors(errors);

    // Nếu có lỗi thì không gửi
    if (Object.values(errors).some((err) => err)) return;
    const token = await execute('submit');

    const res = await fetch(`${BASE_URL}/feedbacks/verifyRecapcha`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ recaptchaToken: token }),
    });
    const verifyResult = await res.json();
    if (verifyResult.message == 'Success') {
      const payload = {
        content: message,
        letterId: id,
        status: 'pending',
        ...formData,
      };

      try {
        await fetch(`${BASE_URL}/feedbacks`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });

        setShowPopup(false);
        setMessage('');
        setFormData({ fullName: '', phoneNumber: '', email: '' });
        setToastMessage('Thêm thông tin khảo sát thành công!');
        setShowToast(true);
        fetchFeedbacks(page);
      } catch (error) {
        alert(`Có lỗi xảy ra! ${error}`);
      }
    } else {
      setToastMessage('Xác minh reCAPTCHA thất bại!');
    }
  };

  useEffect(() => {
    fetchFeedbacks(page);
  }, [page]);

  return (
    <div>
      <label htmlFor="message" className="block mt-2 text-sm font-medium text-gray-900 ">
        {t('articleDetail.feedbackHelp')}
      </label>
      <textarea
        id="message"
        rows="4"
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        className="block p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300
                                 focus:ring-blue-500 focus:border-blue-500 "
        placeholder={locale === 'vi' ? 'Nhập nội dung phản hồi bài viết' : 'Enter article feedback content '}></textarea>
      {formErrors.message && <p className="text-red-500 text-sm mt-1">{formErrors.message}</p>}
      <div className="flex justify-end">
        <button
          type="button"
          onClick={handleSave}
          className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br 
                                focus:ring-4 focus:outline-none focus:ring-blue-300  font-medium rounded-lg 
                                text-sm px-5 py-2.5 text-center me-2 mt-2 mb-4 !ml-auto">
          {t('articleDetail.sendFeedback')}
        </button>
      </div>

      {(feedbacks?.results ?? []).length > 0 && (
        <>
          <div className="w-full space-y-4">
            <h1 className="text-3xl font-bold text-center mb-6">{t('articleDetail.feedbackList')}</h1>
            {(feedbacks?.results ?? []).map((fb, index) => (
              <div key={index} className="bg-white shadow-lg rounded-lg p-4">
                <p>
                  <strong>{t('articleDetail.feedbackFields.fullName')}:</strong> {fb.fullName}
                </p>
                {/* <p>
                  <strong>{t('articleDetail.feedbackFields.phone')}:</strong> {fb.phoneNumber}
                </p>
                <p>
                  <strong>{t('articleDetail.feedbackFields.email')}:</strong> {fb.email}
                </p> */}
                <p>
                  <strong>{t('articleDetail.feedbackFields.content')}:</strong> {fb.content}
                </p>
              </div>
            ))}
          </div>
          <div className="mt-6 flex gap-4 justify-end">
            <button
              onClick={() => setPage((prev) => Math.max(prev - 1, 1))}
              disabled={page === 1}
              className="p-1 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50 ">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path
                  d="M12.2108 16.3332C11.9167 16.3331 11.6347 16.2103 11.4268 15.9918L6.99129 11.3308C6.78341 11.1123 
              6.66663 10.816 6.66663 10.507C6.66663 10.198 6.78341 9.90169 6.99129 9.68318L11.4268 5.02224C11.5291 
              4.91094 11.6515 4.82217 11.7867 4.76111C11.922 4.70004 12.0675 4.66789 12.2148 4.66655C12.362 4.6652 
              12.508 4.69469 12.6443 4.75327C12.7806 4.81186 12.9044 4.89839 13.0085 5.00779C13.1126 5.1172 13.195 
              5.2473 13.2507 5.3905C13.3065 5.53371 13.3345 5.68714 13.3333 5.84186C13.332 5.99658 13.3014 6.14948 
              13.2433 6.29165C13.1852 6.43381 13.1007 6.56239 12.9948 6.66988L9.34322 10.507L12.9948 14.3441C13.1498
               14.5071 13.2554 14.7147 13.2981 14.9407C13.3409 15.1667 13.3189 15.4009 13.235 15.6138C13.1511 15.8267 
               13.009 16.0087 12.8267 16.1367C12.6444 16.2648 12.4301 16.3331 12.2108 16.3332Z"
                  fill="#fff"
                />
              </svg>
            </button>
            <div className="flex flex-wrap gap-2 justify-center items-center">
              {Array.from({ length: totalPages }, (_, i) => (
                <button
                  key={i}
                  onClick={() => setPage(i + 1)}
                  className={`px-3 py-1 rounded
                     border ${page === i + 1 ? 'bg-blue-500 text-white font-semibold' : 'bg-white text-gray-800 border-gray-300'} hover:bg-blue-100`}>
                  {i + 1}
                </button>
              ))}
            </div>
            <button
              onClick={() => setPage((prev) => Math.min(prev + 1, totalPages))}
              disabled={page === totalPages}
              className="p-1 bg-blue-500 text-white rounded hover:bg-blue-600 disabled:opacity-50">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
                <path
                  d="M7.78913 16.3332C7.56985 16.3331 7.35551 16.2648 7.1732 16.1367C6.99089 16.0087 
                6.84879 15.8267 6.76488 15.6138C6.68098 15.4009 6.65902 15.1667 6.70178 14.9407C6.74455 
                14.7147 6.85012 14.5071 7.00515 14.3441L10.6567 10.507L7.00515 6.66988C6.89925 6.56239 
                6.81477 6.43381 6.75665 6.29165C6.69854 6.14948 6.66795 5.99658 6.66667 5.84186C6.66539 
                5.68714 6.69345 5.53371 6.7492 5.3905C6.80496 5.2473 6.88729 5.1172 6.99141 5.00779C7.09553 
                4.89839 7.21933 4.81186 7.35561 4.75327C7.49189 4.69469 7.6379 4.6652 7.78514 4.66655C7.93238 
                4.66789 8.07788 4.70004 8.21317 4.76111C8.34846 4.82217 8.47082 4.91094 8.57311 5.02224L13.0086 
                9.68318C13.2165 9.90169 13.3333 10.198 13.3333 10.507C13.3333 10.816 13.2165 11.1123 13.0086 
                11.3308L8.57311 15.9918C8.3652 16.2103 8.0832 16.3331 7.78913 16.3332Z"
                  fill="#fff"
                />
              </svg>
            </button>
          </div>
        </>
      )}
      {showPopup && (
        <div className="fixed inset-0 flex items-center justify-center bg-black/20 bg-opacity-50">
          <div className="bg-white p-6 rounded-lg shadow-lg w-96">
            <h2 className="text-lg font-medium mb-4">{locale === 'vi' ? 'Nhập thông tin của bạn' : 'Enter your information'}</h2>
            <div>
              <label htmlFor="fullName" className="block mb-2 text-sm font-medium text-gray-900 ">
                {t('articleDetail.feedbackFields.fullName')} <span className="text-red-600">*</span>
              </label>

              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleInputChange}
                placeholder={locale === 'vi' ? 'Nhập họ và tên' : 'Enter full name'}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 
              block w-full p-2.5 "
              />
              {formErrors.fullName && <p className="text-red-500 text-sm mt-1">{formErrors.fullName}</p>}
            </div>
            <div className="mt-2">
              <label htmlFor="phoneNumber" className="block mb-2 text-sm font-medium text-gray-900 ">
                {t('articleDetail.feedbackFields.phone')} <span className="text-red-600">*</span>
              </label>
              <input
                type="text"
                name="phoneNumber"
                value={formData.phoneNumber}
                onChange={handleInputChange}
                placeholder={locale === 'vi' ? 'Nhập số điện thoại' : 'Enter phone number'}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 
              block w-full p-2.5 "
              />
              {formErrors.phoneNumber && <p className="text-red-500 text-sm mt-1">{formErrors.phoneNumber}</p>}
            </div>
            <div className="mt-2 mb-2">
              <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 ">
                {t('articleDetail.feedbackFields.email')} <span className="text-red-600">*</span>
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleInputChange}
                placeholder={locale === 'vi' ? 'Nhập email' : 'Enter email'}
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 
              block w-full p-2.5 "
              />
              {formErrors.email && <p className="text-red-500 text-sm mt-1">{formErrors.email}</p>}
            </div>
            <div className="flex justify-end">
              <button onClick={() => setShowPopup(false)} className="text-gray-700 bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded mr-2">
                {locale === 'vi' ? 'Đóng' : 'Close'}
              </button>
              <button onClick={handleSubmit} type="submit" className="text-white bg-blue-600 hover:bg-blue-700 px-4 py-2 rounded">
                {locale === 'vi' ? 'Gửi' : 'Send'}
              </button>
            </div>
          </div>
        </div>
      )}
      <Toast message={toastMessage} show={showToast} onClose={() => setShowToast(false)} />
    </div>
  );
}
